import { render } from "./MdWave.vue?vue&type=template&id=622c9cdc"
import script from "./MdWave.vue?vue&type=script&lang=js"
export * from "./MdWave.vue?vue&type=script&lang=js"

import "./MdWave.vue?vue&type=style&index=0&id=622c9cdc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__